/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Kiotviet_Unlinked_NoticeInputs */

const vi_kiotviet_unlinked_notice = /** @type {(inputs: Kiotviet_Unlinked_NoticeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đơn có ${i?.count} dòng chưa nối sản phẩm. Nối sản phẩm trước khi xuất kho.`)
};

/**

* @param {Kiotviet_Unlinked_NoticeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const kiotviet_unlinked_notice = /** @type {((inputs: Kiotviet_Unlinked_NoticeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kiotviet_Unlinked_NoticeInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_kiotviet_unlinked_notice(inputs)
});